import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "as-bracket-round__item--team" }

import { ref, computed, onMounted, nextTick } from "vue";
import type {
  IMatch,
  ITournamentJsonData,
  ITournamentRound,
} from "~src/interfaces/tennis";
import BracketItemMatch from "./BracketItemMatch.vue";
import {
  getMappingGroups,
  findGroupByMatchId,
} from "~src/helpers/tennis";
import NoData from "~src/components/NoData.vue";


const __default__ = {};

interface IProps {
  tournament: ITournamentJsonData;
  match: IMatch;
  isHomePage: boolean;
}


export default /*@__PURE__*/_defineComponent({
  ...__default__,
  __name: 'BracketTabList',
  props: {
    tournament: {},
    match: {},
    isHomePage: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props;

const rounds = computed<ITournamentRound[]>(() => {
  let rounds = props.tournament.rounds;
  rounds = rounds.sort(
    (a: ITournamentRound, b: ITournamentRound) => a.number - b.number
  );
  return rounds;
});

const isShow = computed<boolean>(() => {
  if (props.tournament.rounds) {
    return true;
  }

  return false;
});

const getIsShowTheChampion = (round: any) => {
  if (round?.abbr === "F" || (round?.name).toUpperCase() === "FINAL") {
    return true;
  }

  return false;
};
const getGroup = computed<any>(() => {
  const __rounds = props.tournament.rounds;
  const groups = props.tournament.groups;
  const match_ups = props.tournament.match_ups;
  const teams = props.tournament.teams;
  const matches = props.tournament.matches ?? [];

  if (groups && match_ups) {
    const _groups = getMappingGroups(groups, __rounds, match_ups, teams, matches);
    if (_groups) {
      const _group = findGroupByMatchId(_groups, props.match.id);
      const _mappingRounds = _group ? _group.rounds : null;
      if (_mappingRounds) {
        _mappingRounds.sort((a, b) => {
          const lengthA = a.match_ups ? a.match_ups.length : 0;
          const lengthB = b.match_ups ? b.match_ups.length : 0;
          return lengthB - lengthA;
        });

        return _group;
      }
    }
  }

  return null;
});

const mappingRounds = computed<any>(() => {
  const group = getGroup.value;
  const mappingRounds = group ? group.rounds : [];

  console.log("mappingRounds: ", mappingRounds);
  return mappingRounds;
});

const schematicWidth = computed(() => {
  return `${mappingRounds.value.length * 250}px`;
});

const schematicHeight = computed(() => {
  return bodySchematicHeight.value + 50;
});

const getMaxHeightBracketRound = computed(() => {
  const __rounds = mappingRounds.value ? mappingRounds.value : [];
  if (__rounds) {
    const _length = __rounds[0].match_ups.length;
    return _length * 87 + _length * 10;
  }

  return 500;
});

const bodySchematicHeight = computed(() => {
  let __height = 0;
  let __match_ups = mappingRounds.value
    ? mappingRounds.value[0].match_ups.length
    : 0;
  console.log("__match_ups: ", __match_ups);
  if (__match_ups) {
    __height = Math.floor(__match_ups) * 94;
  }

  return __height;
});

const head = ref(null);
const body = ref<HTMLDivElement | null>(null);
const container = ref<HTMLDivElement | null>(null);
// Function to scroll to the active item
const scrollToActiveItem = () => {
  const activeItem = body.value?.querySelector(
    ".as-schematic-item__body.as-active"
  );
  if (activeItem) {
    activeItem.scrollIntoView({
      behavior: "smooth",
      block: "center",
      inline: "center",
    });
  } else {
    console.log("No round active");
  }
};

// Use onMounted lifecycle hook to scroll after component is mounted
onMounted(async () => {
  await nextTick();
  body.value = document.querySelector(".as-schematic__body");
  setTimeout(scrollToActiveItem, 100);
});

return (_ctx: any,_cache: any) => {
  return (getGroup.value)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        ref_key: "container",
        ref: container,
        class: "as-schematic",
        style: _normalizeStyle({ width: schematicWidth.value })
      }, [
        _createElementVNode("div", {
          ref_key: "head",
          ref: head,
          class: "as-schematic__head"
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getGroup.value.rounds, (round, indexRound) => {
            return (_openBlock(), _createElementBlock("span", { key: indexRound }, _toDisplayString(round.name), 1))
          }), 128))
        ], 512),
        _createElementVNode("div", {
          ref_key: "body",
          ref: body,
          class: "as-schematic__body as-new"
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(mappingRounds.value, (rounds, _index) => {
            return (_openBlock(), _createElementBlock("div", {
              style: _normalizeStyle({ maxHeight: getMaxHeightBracketRound.value + 'px' }),
              class: _normalizeClass(["as-bracket-round", `as-bracket-round__as-${_index}`]),
              key: rounds.id
            }, [
              (rounds?.match_up_chunks)
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(rounds.match_up_chunks, (matches, _key) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: _normalizeClass(["as-bracket-round__item", `as-bracket-round__item__as-bracket__${_index}-item__${_key}`]),
                      key: _key
                    }, [
                      _createElementVNode("div", _hoisted_1, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(matches, (matchItem) => {
                          return (_openBlock(), _createBlock(BracketItemMatch, {
                            match: matchItem,
                            matchID: _ctx.match.id,
                            isShowTheChampion: getIsShowTheChampion(rounds)
                          }, null, 8, ["match", "matchID", "isShowTheChampion"]))
                        }), 256))
                      ]),
                      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "as-bracket-round__item--connecter" }, null, -1)),
                      _cache[1] || (_cache[1] = _createElementVNode("div", { class: "as-bracket-round__item--line" }, null, -1))
                    ], 2))
                  }), 128))
                : _createCommentVNode("", true)
            ], 6))
          }), 128))
        ], 512)
      ], 4))
    : (_openBlock(), _createBlock(NoData, { key: 1 }))
}
}

})